export class RelativeURL {
    // https://stackoverflow.com/a/78089652
    // https://www.rfc-editor.org/rfc/rfc2557.html#section-5
    private static readonly PREFIX: string = 'thismessage:/';
    private readonly url: URL;

    private static parse(url: string): URL {
        try {
            new URL(url);
            throw new Error(`Invalid relative URL: ${url}`);
        } catch {
            // Ignore errors
        }

        return new URL(url, RelativeURL.PREFIX);
    }

    constructor(url: string) {
        this.url = RelativeURL.parse(url);
    }

    public get hash(): string {
        return this.url.hash;
    }

    public set hash(hash: string) {
        this.url.hash = hash;
    }

    public get href(): string {
        return this.url.href.substring(RelativeURL.PREFIX.length - 1);
    }

    public set href(href: string) {
        this.url.href = RelativeURL.parse(href).href;
    }

    public get pathname(): string {
        return this.url.pathname;
    }

    public set pathname(pathname: string) {
        this.url.pathname = pathname;
    }

    public get search(): string {
        return this.url.search;
    }

    public set search(search: string) {
        this.url.search = search;
    }

    public get searchParams(): URLSearchParams {
        return this.url.searchParams;
    }

    public static fromAbsolute(absolute: URL | string): RelativeURL {
        let url: URL;
        if (absolute instanceof URL) {
            url = absolute;
        } else {
            url = new URL(absolute);
        }

        return new RelativeURL(`${url.pathname}${url.search}${url.hash}`);
    }

    public toAbsolute(base: string | URL): URL {
        return new URL(this.href, base);
    }

    // https://developer.mozilla.org/en-US/docs/Web/API/URL/toString
    public toString(): string {
        return this.href;
    }
}
